"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ReactShadowRoot = _interopRequireDefault(require("./ReactShadowRoot.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _ReactShadowRoot["default"];
exports["default"] = _default;